import React from 'react';
import { Typography, useTheme } from '@mui/material';
import { getTopographyStyle } from '../helpers';
import { tokens } from 'theme';
import { useSidebarStatus } from '../hooks';
import { SidebarItem } from './sidebar-item';
import { SidebarItemType } from '../types/sidebar-item.type';
import { useAppSelector } from 'hooks';
import { UserRoleType } from 'types/types';

type SideBarItem = SidebarItemType & { roleAllowed?: UserRoleType[] };

type Properties = {
  groupTitle?: string;
  items: SideBarItem[];
};

export const SideBarGroup: React.FC<Properties> = ({ groupTitle, items }) => {
  const { isSidebarOpen: isCollapsed } = useSidebarStatus();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const userRole = useAppSelector(({ user }) => user.data?.role);

  return (
    <>
      {groupTitle && (
        <Typography variant='h6' color={colors.grey[300]} sx={getTopographyStyle(isCollapsed)}>
          {groupTitle}
        </Typography>
      )}
      {items.map((item) => {
        if (item.roleAllowed) {
          return item.roleAllowed.includes(userRole) && <SidebarItem key={item.title} {...item} />;
        }

        return <SidebarItem key={item.title} {...item} />;
      })}
    </>
  );
};
